import React, { createContext, useContext } from 'react';
import { Auth0Provider } from '@auth0/auth0-react';

// Auth0 integration for Wolf Goat Pig authentication
const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const domain = import.meta.env.VITE_AUTH0_DOMAIN;
  const clientId = import.meta.env.VITE_AUTH0_CLIENT_ID;
  const audience = import.meta.env.VITE_AUTH0_AUDIENCE;

  if (!domain || !clientId) {
    throw new Error('Please define VITE_AUTH0_DOMAIN and VITE_AUTH0_CLIENT_ID environment variables');
  }

  if (import.meta.env.DEV) {
    console.debug('🔧 Auth0 Configuration:', {
      domain,
      clientId: clientId.substring(0, 8) + '...',
      redirectUri: window.location.origin
    });
  }

  const value = {
    // Additional auth context values can be added here
  };

  try {
    return (
      <Auth0Provider
        domain={domain}
        clientId={clientId}
        authorizationParams={{
          redirect_uri: window.location.origin,
          ...(audience && { audience }),
          scope: "openid profile email offline_access"
        }}
        cacheLocation="localstorage"
        useRefreshTokens={true}
        // Fall back to a silent /authorize iframe when the cached refresh token
        // is missing or expired, instead of throwing "Missing Refresh Token".
        useRefreshTokensFallback={true}
      >
        <AuthContext.Provider value={value}>
          {children}
        </AuthContext.Provider>
      </Auth0Provider>
    );
  } catch (error) {
    console.error('Auth0Provider initialization failed:', error);
    // Return a fallback provider that won't crash the app
    return (
      <AuthContext.Provider value={{}}>
        {children}
      </AuthContext.Provider>
    );
  }
};

export default AuthProvider;
